import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'smartNumber',
    standalone: false
}) 
export class SmartNumber implements PipeTransform {

    constructor() { }

    transform(value: any): string {
        if (value === null || value === undefined) return '';

        if (typeof value === 'string') {
            value = parseFloat(value.replace(',', '.'));
        }

        if (typeof value !== 'number' || isNaN(value)) return '';
        const decimalsMax = 10;
        const factor = Math.pow(10, decimalsMax);
        value = Math.round(value * factor) / factor;

        let str = value.toFixed(decimalsMax);

        str = str.replace(/\.?0+$/, '');

        return str;
    }
}